import { motion } from "framer-motion";
import { Quote } from "lucide-react";

export const Testimonials = ({ t }) => (
  <section id="testimonials" className="py-28 bg-[#0A101D] relative overflow-hidden">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="mb-16"
      >
        <p className="text-xs tracking-[0.35em] uppercase font-mono text-[#E2C376] mb-5 flex items-center gap-3">
          <span className="w-10 h-px bg-[#D4AF37]" /> {t.testimonials.eyebrow}
        </p>
        <h2 data-testid="testimonials-heading" className="font-serif text-2xl sm:text-3xl lg:text-4xl text-slate-50 tracking-tight max-w-xl">
          {t.testimonials.title}
        </h2>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
        {t.testimonials.items.map((item, i) => (
          <motion.figure
            key={i}
            data-testid={`testimonial-card-${i + 1}`}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: i * 0.12 }}
            className="group relative bg-[#111A2E] border border-[#D4AF37]/15 p-8 lg:p-10 hover:border-[#D4AF37]/50 transition-colors duration-500 flex flex-col"
          >
            <div className="absolute top-0 left-0 w-0 h-px bg-[#D4AF37] group-hover:w-full transition-all duration-700" />
            <Quote className="w-8 h-8 text-[#D4AF37]/50 mb-6" strokeWidth={1} />
            <blockquote className="font-serif text-lg italic text-slate-200 leading-relaxed mb-8 flex-1">
              «&nbsp;{item.quote}&nbsp;»
            </blockquote>
            <figcaption className="border-t border-[#D4AF37]/10 pt-5">
              <div className="text-sm text-[#E2C376] font-medium">{item.author}</div>
              <div className="text-xs text-slate-500 font-mono uppercase tracking-widest mt-1">{item.role}</div>
            </figcaption>
          </motion.figure>
        ))}
      </div>
    </div>
  </section>
);
